<template>
  <div>
    <Desktop v-if="!mobile" />
    <Mobile v-else />
  </div>
</template>

<script>
import Desktop from "./Desktop.vue";
import Mobile from "./Mobile.vue";

export default {
  computed: {
    mobile() {
      return this.$vuetify.breakpoint.smAndDown;
    },
  },
  components: {
    Desktop,
    Mobile,
  },
};
</script>
